<script lang="ts">
  import TemplateSelection from '../../lib/editor/TemplateSelection/TemplateSelection.svelte';
  import editorStore from '../../lib/editor/editor.store';

  function changeTemplate() {
    editorStore.toggleStylebar(false);
    editorStore.setPopoverComponent(TemplateSelection, 'Template Selection');
  }
</script>

<div class="grid w-full gap-2 px-4 py-4">
  <span class="text-sm font-bold text-zinc-800">Change Template</span>
  <button
    on:click={changeTemplate}
    class="rounded-lg border border-zinc-200 bg-primary px-4 py-3 text-sm font-bold text-white hover:bg-primary-500"
  >
    Choose A New Template
  </button>
</div>
